import React, { FC } from 'react';
import { DashboardContainerLayout } from 'common/pages/LayoutPage';
import { Switch } from 'react-router';
import {
  AccountRoute,
  BusinessPartnersManagementRoute,
  DevicesManagementRoute,
  DoctorsRoute,
  PatientsRoute,
  UsersRoute,
} from 'routes';
import { PrivateRoute } from 'common/AuthRoute';
import DevicesManagementPage from 'pages/SuperAdminModule/DevicesManagement';
import { BusinessPartnersManagementPage } from 'pages/SuperAdminModule/BusinessPartnersManagement';
import { ProfileOwnersPage } from 'pages/SuperAdminModule/ProfileOwnersPage';
import { DoctorsPage } from 'pages/SuperAdminModule/DoctorsPage';
import { PatientsPage } from 'pages/SuperAdminModule/PatientsPage';
import { SuperAdminModuleMenu } from 'pages/SuperAdminModule/SuperAdminModuleMenu';
import { AccountManagementRouter } from 'pages/AccountManagement/AccountManagementRouter';

const SuperAdminModule: FC = () => {
  return (
    <DashboardContainerLayout menu={<SuperAdminModuleMenu />}>
      <Switch>
        <PrivateRoute path={AccountRoute} component={AccountManagementRouter} />
        <PrivateRoute
          path={DevicesManagementRoute}
          component={DevicesManagementPage}
        />
        <PrivateRoute
          path={BusinessPartnersManagementRoute}
          component={BusinessPartnersManagementPage}
        />

        <PrivateRoute path={DoctorsRoute} component={DoctorsPage} />
        <PrivateRoute path={PatientsRoute} component={PatientsPage} />
        <PrivateRoute path={UsersRoute} component={ProfileOwnersPage} />
      </Switch>
    </DashboardContainerLayout>
  );
};

// eslint-disable-next-line import/no-default-export
export default SuperAdminModule;
